(function () {
  if (window.NatureProjectDonation && window.NatureProjectDonation.version === '3') {
    window.NatureProjectDonation.initAll(document);
    return;
  }

  const donationState =
  window.NatureProjectDonationStateV3 ||
  (window.NatureProjectDonationStateV3 = new Map());

function initDonationAddon(addon) {
  if (addon.dataset.donationInitialized === 'true') return;

  addon.dataset.donationInitialized = 'true';

  const stateKey = addon.dataset.donationStateKey;

  const toggle = addon.querySelector('[data-donation-toggle]');
  const customToggle = addon.querySelector('[data-donation-custom-toggle]');
  const amountsWrapper = addon.querySelector('[data-donation-amounts]');
  const amountButtons = addon.querySelectorAll('[data-donation-amount-option]');
  const selectedMoney = addon.querySelector('[data-donation-selected-money]');

  const defaultVariantId = addon.dataset.defaultDonationVariantId;
  const defaultPrice = addon.dataset.defaultDonationPrice;
  const defaultMoney =
    addon.dataset.defaultDonationMoney || addon.dataset.donationMoney;

  let state = donationState.get(stateKey);

  if (!state) {
    state = {
      enabled: false,
      variantId: null,
      price: null,
      money: null,
      customOpen: true
    };

    donationState.set(stateKey, state);
  }

  const syncUI = () => {
    toggle.checked = state.enabled;

    addon.dataset.donationVariantId = state.variantId;
    addon.dataset.donationPrice = state.price;
    addon.dataset.donationMoney = state.money;
    addon.dataset.donationEnabled = state.enabled ? 'true' : 'false';

    if (selectedMoney && state.money) {
      selectedMoney.textContent = state.money;
    }

    amountButtons.forEach((button) => {
      const selected =
        button.dataset.donationVariantId === state.variantId;

      button.classList.toggle('is-selected', selected);
      button.setAttribute(
        'aria-pressed',
        selected ? 'true' : 'false'
      );
    });

    if (amountsWrapper) {
      amountsWrapper.hidden = !state.customOpen;
    }

    if (customToggle) {
      customToggle.setAttribute(
        'aria-expanded',
        state.customOpen ? 'true' : 'false'
      );
    }
  };

  toggle.addEventListener('change', () => {
    state.enabled = toggle.checked;

    donationState.set(stateKey, state);
    syncUI();
  });

  customToggle?.addEventListener('click', () => {
    state.customOpen = !state.customOpen;

    donationState.set(stateKey, state);
    syncUI();
  });

  amountButtons.forEach((button) => {
    button.addEventListener('click', () => {
      state.variantId = button.dataset.donationVariantId;
      state.price = button.dataset.donationPrice;
      state.money = button.dataset.donationMoney;

      // Choosing an amount automatically enables donation.
      state.enabled = true;

      donationState.set(stateKey, state);

      syncUI();
    });
  });

  syncUI();
}

function initDonationAddons(root = document) {
  root
    .querySelectorAll('[data-donation-addon]')
    .forEach(initDonationAddon);
}

initDonationAddons();

  function initAll(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-donation-addon]')) {
      initDonationAddon(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-donation-addon]').forEach(initDonationAddon);
    }
  }

  function getSelection(productInformation) {
    if (!productInformation) return null;

    var block = productInformation.querySelector(
      '[data-donation-addon][data-donation-variant-id]'
    );
    if (!block) return null;

    initDonationAddon(block);
    var toggle = block.querySelector('[data-donation-toggle]');
    var variantId = parseInt(block.getAttribute('data-donation-variant-id'), 10);

    if (!toggle || !toggle.checked || !Number.isInteger(variantId)) return null;
    return { variantId: variantId };
  }

  window.NatureProjectDonation = {
    version: '3',
    getSelection: getSelection,
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === Node.ELEMENT_NODE) initAll(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
